export default __webpack_public_path__ + "static/media/doc2.00930e6b.jpg";